<template>
    <div>
        <header class="mui-bar mui-bar-nav">
            <h1 class="mui-title">充值</h1>
        </header> 
        <div class="mui-content">
            <div>
                <p class="title">基本信息</p>
                <ul class="mui-table-view">
                    <li class="mui-table-view-cell mui-media">
                        <a href="javascript:;">
                            <div class="mui-media-body mui-pull-left">
                                区域编号
                            </div>
                            <div class="mui-media-body mui-pull-right mui-text-right">
                                {{fadeInfo.facade_code}}
                            </div>
                        </a>
                    </li>
                    <li class="mui-table-view-cell mui-media">
                        <a href="javascript:;">
                            <div class="mui-media-body mui-pull-left">
                                区域名称
                            </div>
                            <div class="mui-media-body mui-pull-right mui-text-right">
                                {{fadeInfo.facade_name}}
                            </div>
                        </a>
                    </li>
                    <li class="mui-table-view-cell mui-media">
                        <a href="javascript:;">
                            <div class="mui-media-body mui-pull-left">
                                区域状态
                            </div>
                            <div class="mui-media-body mui-pull-right mui-text-right">
                                <!--0未开户 1正常 2欠费-->
                                {{fadeInfo.facade_state == 1 ?'正常':(fadeInfo.facade_state == 2 ?'欠费':'未开户')}}
                            </div>
                        </a>
                    </li>
                    <li class="mui-table-view-cell mui-media">
                        <a href="javascript:;">
                            <div class="mui-media-body mui-pull-left">
                                余额
                            </div>
                            <div class="mui-media-body mui-pull-right mui-text-right">
                                {{fadeInfo.balance}}元
                            </div>
                        </a>
                    </li>
                </ul>            
            </div>	
            <div>
                <p class="title" style="margin-top: 35px;">操作</p>
                <form class="mui-input-group">
                    <div class="mui-input-row">
                        <label>充值金额（元）</label>
                        <input type="number" class="mui-input-clear" v-model="money" style="font-size: 14px;text-align: right; padding-right: 45px;" placeholder="请输入金额">
                    </div>
                    <div class="mui-button-row" style="padding: 20px;">
                        <button type="button" class="mui-btn mui-btn-primary mui-btn-block" @click="chongzhi">确认</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<script>
    import { GetFacadeInfo,PayOrder_Add,PublicPay } from '@/request/api';
    export default{
        data: function(){
            return {
                urlInfo:{},
                fadeInfo: {},
                money:'',
            }
        },
        mounted(){
            var urlInfo = this.$route.query;
            this.urlInfo = urlInfo;
            if(this.urlInfo.facade_id){
                this.getMoreInfo();
            }
        },
        methods:{
            getMoreInfo(){
                //获取近半年的信息。
                GetFacadeInfo({     
                    "facade_id":this.urlInfo.facade_id
                    }).then(res => {
                    // 获取数据成功后的其他操作
                    if(res.result =='true'){
                        this.fadeInfo = res.data;
                    }
                    else{
                        mui.toast(res.description,{ duration:'long'});	
                    }
                }) 
            },
            chongzhi(){
                var _this = this;
                //充值。
                PayOrder_Add({     
                    "facade_id": this.fadeInfo.facade_id,
                    "tenant_id":this.fadeInfo.tenant_id,
                    "pay_account": this.money,
                    "order_account": this.money,
                    "openid":this.urlInfo.openid
                    }).then(res => {
                    // 获取数据成功后的其他操作
                    if(res.result =='true'){
                       console.log("成功");
                       //调用支付接口，进行支付。
                       var userKy = res.UserKey;
                       if(userKy){
                        PublicPay({     
                            "order_id": userKy
                            }).then(result => {
                                if(result.result == 'true'){
                                    var orderInf = result.data.OrderInfo;
                                    if (typeof WeixinJSBridge == "undefined"){
                                        if( document.addEventListener ){
                                            document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
                                        }else if (document.attachEvent){
                                            document.attachEvent('WeixinJSBridgeReady', onBridgeReady); 
                                            document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
                                        }
                                    }else{
                                        // mui.alert(orderInf,{ duration:'long'});	
                                        var myJSon = JSON.parse(orderInf);
                                        myJSon.timeStamp = myJSon.timeStamp+''
                                        WeixinJSBridge.invoke(
                                            'getBrandWCPayRequest',myJSon,
                                            function(res){
                                            if(res.err_msg == "get_brand_wcpay_request:ok" ){
                                            // 使用以上方式判断前端返回,微信团队郑重提示：
                                                    //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                                            } else{
                                                mui.alert('支付失败');
                                            }
                                        }); 
                                    }
                                }else{
                                    mui.alert('调取微信支付失败');
                                }
                            })
                       }
                    }
                    else{
                        mui.toast(res.description,{ duration:'long'});	
                    }
                }) 
            }
        },
        onBridgeReady(json){
            WeixinJSBridge.invoke(
                'getBrandWCPayRequest',json,
                function(res){
                if(res.err_msg == "get_brand_wcpay_request:ok" ){
                // 使用以上方式判断前端返回,微信团队郑重提示：
                        //res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                        alert('1111');
                } 
            }); 
        }
    }
    
</script>
<style>
        @import '../common/css/public.css';
        .mui-input-group:after{
            background: transparent;
        }
</style>


// WEBPACK FOOTER //
// src/pages/weixinPay.vue